function validDate(value) {
  const date = new Date(value);

  return Number.isFinite(date.getTime()) ? date : null;
}

export function formatTime(value) {
  const date = validDate(value);

  return date
    ? new Intl.DateTimeFormat("en", { hour: "numeric", minute: "2-digit" }).format(date)
    : "Time unavailable";
}

export function formatDate(value) {
  const date = validDate(value);

  return date
    ? new Intl.DateTimeFormat("en", { weekday: "long", month: "short", day: "numeric" }).format(date)
    : "Date unavailable";
}

export function dateInput(value) {
  const date = validDate(value);

  if (!date) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function currentWeekRange() {
  const today = new Date();
  const day = today.getDay() || 7;
  const start = new Date(today);
  const end = new Date(today);

  start.setDate(today.getDate() - day + 1);
  start.setHours(0, 0, 0, 0);
  end.setTime(start.getTime());
  end.setDate(start.getDate() + 6);
  end.setHours(23, 59, 59, 999);

  return {
    startDate: dateInput(start),
    endDate: dateInput(end),
  };
}

export function dateStart(value) {
  return new Date(`${value}T00:00:00`);
}

export function dateEnd(value) {
  return new Date(`${value}T23:59:59`);
}

export function shiftDateRange(range, direction) {
  const start = dateStart(range.startDate);
  const end = dateEnd(range.endDate);
  const dayMs = 86400000;
  const stepDays = Math.max(1, Math.round((end.getTime() - start.getTime()) / dayMs));

  start.setDate(start.getDate() + direction * stepDays);
  end.setDate(end.getDate() + direction * stepDays);

  return {
    startDate: dateInput(start),
    endDate: dateInput(end),
  };
}

export function localDayRange(value) {
  const date = new Date(value);
  const start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
  const end = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);

  return {
    start: start.toISOString(),
    end: end.toISOString(),
  };
}

export function addDays(date, days) {
  const next = new Date(date);

  next.setDate(next.getDate() + days);

  return next;
}

export function elapsedSeconds(entry) {
  if (!entry) {
    return 0;
  }

  const base = entry.durationSeconds || 0;

  if (!entry.isRunning) {
    return base;
  }

  const startTime = validDate(entry.startTime);

  if (!startTime) {
    return base;
  }

  return base + Math.max(0, Math.floor((Date.now() - startTime.getTime()) / 1000));
}

export function formatDuration(seconds) {
  const safe = Math.max(0, seconds || 0);
  const h = String(Math.floor(safe / 3600)).padStart(2, "0");
  const m = String(Math.floor((safe % 3600) / 60)).padStart(2, "0");
  const s = String(safe % 60).padStart(2, "0");

  return `${h}:${m}:${s}`;
}

export function formatHoursMinutes(seconds) {
  const safe = Math.max(0, seconds || 0);
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);

  return `${hours}h ${String(minutes).padStart(2, "0")}m`;
}
